import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { FeatureSpecHttpClient } from './feature-spec.http-client';
import { FeatureSpecActions } from './feature-spec.store';

@Injectable({ providedIn: 'root' })
export class FeatureSpecEffects {
  public effects = createEffectFactory(FeatureSpecActions, this.actions$);

  public fetch$ = this.effects(FeatureSpecActions.fetch, () =>
    this.http.fetch().pipe(
      map(response => response.features),
      catchError(error => of({ error })),
    ),
  );

  constructor(
    private actions$: Actions,
    private http: FeatureSpecHttpClient,
  ) {}
}
